module.exports = __webpack_public_path__ + "static/media/ultramax-pumpup-package.6d046cbf.png";